window.addEventListener("load", async () => {
    const selectedContainer = document.getElementById("selected-notes");
    const clearButton = document.getElementById("clear-notes-btn");
    const searchInput = document.getElementById("note-search");
    const resultsBox = document.getElementById("note-search-results");
    const notesFinderView = document.getElementById("finder-view");
    const resultsView = document.getElementById("results-view");
    const searchButton = document.getElementById("search-notes-btn");
    const backButton = document.getElementById("back-to-search-btn");

    let allNotes = [];
    let allProducts = [];
    let selectedNotes = JSON.parse(localStorage.getItem("selectedNotes")) || [];

    const params = new URLSearchParams(window.location.search);
const clickedNote = params.get("note");


if (clickedNote) {

    backButton.style.display = "none";
    selectedNotes = [clickedNote];

    

    sessionStorage.setItem("notesFinderView", "results");

}


    async function fetchSampleProducts() {
        const products = [];
        const root = window.Shopify?.routes?.root || '/';
        for (let page = 1; page <= 100; page++) {
            const url = `${root}collections/all?section_id=pl-finder-data&page=${page}`;
            const response = await fetch(url, { credentials: 'same-origin' });
            if (!response.ok) throw new Error('Finder data unavailable (HTTP ' + response.status + ')');
            const html = await response.text();
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const payload = doc.querySelector('[data-pl-finder-payload]');
            if (!payload) throw new Error('Finder data section is missing');
            const data = JSON.parse(payload.textContent);
            if (!Array.isArray(data.products) || !Number.isInteger(data.pages)) {
                throw new Error('Finder data response is malformed');
            }
            // The collection already selects samples; verify tags again before rendering.
            const eligible = data.products.filter(product =>
                Array.isArray(product.tags) &&
                product.tags.includes('sample') &&
                !product.tags.includes('full-bottle')
            );
            for (const product of eligible) {
                if (!products.some(existing => existing.handle === product.handle)) {
                    products.push(product);
                }
            }
            if (page >= data.pages) return products;
        }
        throw new Error('Finder data exceeds pagination safety limit');
    }


    function updateNoteCounts() {
        const counts = new Map();
        for (const product of allProducts) {
            for (const note of new Set(product.notes)) {
                counts.set(note, (counts.get(note) || 0) + 1);
            }
        }
        document.querySelectorAll('.note-fragrance-count').forEach(element => {
            const count = counts.get(element.dataset.note) || 0;
            element.textContent = `${count} fragrance${count === 1 ? '' : 's'}`;
        });
    }

    async function loadNotes() {
        // Note names are derived from sample products, so unused notes are not suggested.
    }

    async function loadProducts() {
        try {
            const records = await fetchSampleProducts();
            allProducts = records
                .filter(product => Array.isArray(product.notes) && product.notes.length > 0)
                .map(product => ({
                    title: product.title,
                    handle: product.handle,
                    image: product.image || '',
                    notes: product.notes.filter(Boolean)
                }));
            const uniqueNotes = new Set(allProducts.flatMap(product => product.notes));
            allNotes = [...uniqueNotes].map(name => ({ name }))
                .sort((a, b) => a.name.localeCompare(b.name));
        } catch (error) {
            console.error('Could not load sample fragrances for Find by Notes', error);
            const resultsCount = document.querySelector('.results-count');
            if (resultsCount) resultsCount.textContent = 'Unable to load fragrances. Please refresh the page.';
            throw error;
        }
    }

    function searchPerfumes() {
        const matchType = document.querySelector('input[name="match"]:checked').value;
        let results = [];
        allProducts.forEach(product => {
            const matchedNotes = selectedNotes.filter(note => product.notes.includes(note));
            if (
                (matchType === "or" && matchedNotes.length > 0) || (matchType === "and" && matchedNotes.length === selectedNotes.length)) {
                results.push({
                    ...product,
                    matchedNotes,
                    score: matchedNotes.length
                });
            }
        });
        results.sort((a, b) => b.score - a.score);
        renderResults(results);
    }

    function renderResults(results) {
        const resultsGrid = document.querySelector(".perfume-results-grid");
        const resultsCount = document.querySelector(".results-count");
        const resultsTitle = document.getElementById("results-title");

        resultsGrid.innerHTML = "";

if (selectedNotes.length === 1) {
    resultsTitle.textContent = `Matching Fragrances with "${selectedNotes[0]}"`;
} else {
    resultsTitle.textContent = "Matching Fragrances";
}

resultsCount.innerHTML =
    `<h4>${results.length} fragrances found</h4>`;
        results.forEach(product => {
            resultsGrid.innerHTML += `

<a href="/products/${product.handle}" class="perfume-result-card">

    <img src="${product.image}" alt="${product.title}">

    <h4>${product.title}</h4>

    <div class="perfume-match-score">
    ${product.score} / ${selectedNotes.length} matching notes
</div>

<div class="perfume-matched-notes">

    ${product.matchedNotes.map(note => `
        <span class="matched-note">${note}</span>
    `).join("")}

</div>

<div class="view-product">
    View Product →
</div>

</a>

`;
        });
    }

    function saveSelectedNotes() {
        localStorage.setItem("selectedNotes", JSON.stringify(selectedNotes));
    }

    function refreshSelectedNotes() {
        selectedContainer.innerHTML = "";
        if (selectedNotes.length === 0) {
            selectedContainer.innerHTML = '<span class="selected-placeholder">No notes selected</span>';
            return;
        }
        selectedNotes.forEach(note => {
            const chip = document.createElement("div");
            chip.className = "selected-chip";
            chip.innerHTML = `
                ${note}
                <button type="button">×</button>
            `;
            chip.querySelector("button").addEventListener("click", () => {
                selectedNotes = selectedNotes.filter(n => n !== note);
                saveSelectedNotes();
                const card = document.querySelector(`.note-card[data-note="${note}"]`);
                if (card) {
                    card.classList.remove("selected");
                }
                refreshSelectedNotes();
            });
            selectedContainer.appendChild(chip);
        });
    }
    document.querySelectorAll(".note-card").forEach(card => {
        if (selectedNotes.includes(card.dataset.note)) {
            card.classList.add("selected");
        }
        card.addEventListener("click", () => {
            const note = card.dataset.note;
            if (card.classList.contains("selected")) {
                card.classList.remove("selected");
                selectedNotes = selectedNotes.filter(n => n !== note);
            } else {
                card.classList.add("selected");
                if (!selectedNotes.includes(note)) {
                    selectedNotes.push(note);
                }
            }
            saveSelectedNotes();
            refreshSelectedNotes();
        });
    });
    clearButton.addEventListener("click", () => {
        selectedNotes = [];
        saveSelectedNotes();
        document.querySelectorAll(".note-card.selected").forEach(card => {
            card.classList.remove("selected");
        });
        refreshSelectedNotes();
        searchInput.value = "";
        resultsBox.innerHTML = "";
        resultsBox.style.display = "none";
    });
    searchInput.addEventListener("input", () => {
        const search = searchInput.value.trim().toLowerCase();
        resultsBox.innerHTML = "";
        if (search.length < 2) {
            resultsBox.style.display = "none";
            return;
        }
        const matches = allNotes.filter(note => note.name.toLowerCase().includes(search)).filter(note => !selectedNotes.includes(note.name)).slice(0, 10);
        if (matches.length === 0) {
            resultsBox.style.display = "none";
            return;
        }
        matches.forEach(note => {
            const item = document.createElement("div");
            item.className = "note-search-item";
            item.textContent = note.name;
            item.addEventListener("click", () => {
                if (!selectedNotes.includes(note.name)) {
                    selectedNotes.push(note.name);
                    saveSelectedNotes();
                }
                const card = document.querySelector(`.note-card[data-note="${note.name}"]`);
                if (card) {
                    card.classList.add("selected");
                }
                refreshSelectedNotes();
                searchInput.value = "";
                resultsBox.innerHTML = "";
                resultsBox.style.display = "none";
            });
            resultsBox.appendChild(item);
        });
        resultsBox.style.display = "block";
    });
    searchButton.addEventListener("click", () => {
        searchPerfumes();
        sessionStorage.setItem("notesFinderView", "results");
        notesFinderView.style.display = "none";
        resultsView.style.display = "block";
    });
    backButton.addEventListener("click", () => {
        sessionStorage.setItem("notesFinderView", "finder");
        resultsView.style.display = "none";
        notesFinderView.style.display = "block";
    });
    const savedView = sessionStorage.getItem("notesFinderView");
    if (savedView === "results") {
        notesFinderView.style.display = "none";
        resultsView.style.display = "block";
    } else {
        notesFinderView.style.display = "block";
        resultsView.style.display = "none";
    }
    await loadNotes();
    await loadProducts();
    updateNoteCounts();
    refreshSelectedNotes();
    if (clickedNote || savedView === "results") {

    searchPerfumes();
    

    notesFinderView.style.display = "none";
    resultsView.style.display = "block";

}

});